import { Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EventService } from 'src/app/core/services/event.service';
import { SocketIOService } from 'src/app/core/services/socket-io.service';
import { UserService } from 'src/app/core/services/user.service';
import { CommonAlertComponent } from '../common-alert/common-alert.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-linkedin-callback',
    imports: [],
    templateUrl: './linkedin-callback.component.html',
    styleUrl: './linkedin-callback.component.scss'
})
export class LinkedinCallbackComponent implements OnInit, OnDestroy {
	private subs = new Subscription();


	constructor(
		private route:ActivatedRoute,
		private router:Router,
		private linkedinservice:UserService,
		private socketIOService: SocketIOService,
		private eventService: EventService,
		private modalService: NgbModal,
		private toastr: ToastrService
	){}

ngOnInit(): void {
	this.subs.add(this.eventService.subscribe('user-signed-in', (payload: any) => {
		this.userSignIn(payload);
	}));
		// this.subs.add(this.eventService.subscribe('user-signed-up', (payload: any) => {
		// 		if (payload.response.Code === 200 || payload.response.Code === 2001) {
		// 			this.linkedinservice.setCookie('token', payload.response.Data.Token);
		// 			this.linkedinservice.setCookie('stage', '0');
		// 			this.router.navigateByUrl('/mobileVerify');
		// 		} else if (payload.response.Code === 1002) {
		// 			// HAS TO BE HANDLED WITH POPUP
		// 			let modal = this.modalService.open(CommonAlertComponent, { backdrop: 'static', keyboard: false });
		// 			modal.componentInstance.header = 'User with Email exists!';
		// 			modal.componentInstance.msg = 'An user account with this email address already exists. Please try again with a new email address.';
		// 		}
		// 	});
	const code = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('state');
    const savedState = sessionStorage.getItem('oauthState');

    if (!code || !state || state !== savedState) {
      this.toastr.error('LinkedIn sign-in failed. Please try again.');
      this.router.navigate(['/login']);
      return;
    }
	  // Exchange authorization code for access token
	  this.linkedinservice.getAccessToken(code).subscribe(
		(tokenResponse: any) => {
		  const accessToken = tokenResponse;
		  const data=tokenResponse.Data
		  const userData = {
			  linkedinId: data.sub,
			  firstName: data.given_name,
			  lastName: data.family_name,
			  email: data.email,
			  password:''
			};
			  this.nliAuthenticate(userData);
		  // Fetch LinkedIn user profile and email
		//   this.linkedinservice.getLinkedInProfile(accessToken).subscribe(
		// 	(profileResponse: any) => {
		// 	  this.linkedinservice.getLinkedInEmail(accessToken).subscribe(
		// 		(emailResponse: any) => {
		// 		  const userData = {
		// 			linkedinId: profileResponse.id,
		// 			firstName: profileResponse.localizedFirstName,
		// 			lastName: profileResponse.localizedLastName,
		// 			email: emailResponse.elements[0]['handle~'].emailAddress,
		// 			password:''
		// 		  };

		// 		  // Use the `nliAuthenticate` method here
		// 		  this.nliAuthenticate(userData);
		// 		}
		// 	  );
		// 	}
		//   );
		},
		(error:any) => {
		  this.toastr.error('Failed to connect to LinkedIn. Please try again.');
		  this.router.navigate(['/login']);
		}
	  );
	// Used for social login is user exists

}
private userSignIn(args: any) {
	this.linkedinservice.setCookie('token', args.response.Data.Token);
	this.linkedinservice.setCookie('stage', args.response.Data.Stage);
	this.linkedinservice.setCookie('user_id', args.response.Data.User_id);
	this.linkedinservice.setCookie('stageToRedirect', args.response.Data.Stage_To_Redirect);
	// connect messaging service
	if (this.socketIOService.getConnectionStatus() === false ||
		this.socketIOService.getConnectionStatus() === undefined) {
		this.socketIOService.connect();
	}

	if (Number(args.response.Data.Stage) === 5) {
		this.linkedinservice.profileInfo().subscribe((response: any) => {
			if (response.status === 200 && response.Code === 200) {
				this.eventService.broadcast('ShowResumePopup', response);
			}
		});
	}

	let stage = Number(args.response.Data.Stage);
	if (stage === 0) {
		this.linkedinservice.skipState(0).subscribe();
		this.linkedinservice.setCookie('stage', '1');
		stage = 1;
	}

	this.linkedinservice.redirectUser(stage, true);
}
private nliAuthenticate(userData: any): void {
    if (userData.email) {
      this.linkedinservice.linkedinAuth({
		email: userData.email,
		token: userData.linkedinId,
		password: '',
	}).subscribe(
        (response: any) => {
          if (response.status === 200 && response.Code === 401) {
            // User is logging in for the first time; call signup
			let user = {
				email: userData.email,
				firstName: userData.firstName,
				lastName: userData.lastName,
				password: '',
				token: userData.linkedinId || '',
			};
			this.linkedinservice.signUp(user, 'LINKEDIN').subscribe({
				next: (signUpResponse: any) => {
					if (signUpResponse.status === 200) {
						// Immediately try signing in again
						this.linkedinservice.linkedinAuth({
							email: userData.email,
							token: userData.linkedinId,
							password: '',
						}).subscribe((authResponse: any) => {
							if (authResponse.status === 200 && authResponse.Code === 200) {
								this.linkedinservice.setCookie('userEmail', userData.email);
								this.linkedinservice.setCookie('user_id', authResponse.Data.User_id);
								this.eventService.broadcast('user-signed-in', { response: authResponse });
							}
						});
					}
				},
				error: (err: any) => {
					const modal = this.modalService.open(CommonAlertComponent, { backdrop: 'static', keyboard: false });
					modal.componentInstance.header = 'Sign-in failed';
					modal.componentInstance.msg = err?.error?.Message || err?.message || 'Sign-up failed. Please try again.';
					this.router.navigate(['/login']);
				}
			});


          } else if (response.status === 200 && response.Code === 200) {
            // User already exists; set cookies and navigate
            this.linkedinservice.setCookie('userEmail', userData.email);
            this.linkedinservice.setCookie('user_id', response.Data.User_id);
			this.eventService.broadcast('user-signed-in', { response: response });
			// this.router.navigate(['/dashboard']);
          } else {
            const modal = this.modalService.open(CommonAlertComponent, { backdrop: 'static', keyboard: false });
            modal.componentInstance.header = 'Sign-in failed';
            modal.componentInstance.msg = 'An unexpected error occurred during LinkedIn sign-in. Please try again.';
            this.router.navigate(['/login']);
          }
        },
        (error: any) => {
          const modal = this.modalService.open(CommonAlertComponent, { backdrop: 'static', keyboard: false });
          modal.componentInstance.header = 'Sign-in failed';
          modal.componentInstance.msg = 'An unexpected error occurred during LinkedIn sign-in. Please try again.';
          this.router.navigate(['/login']);
        }
      );
    }
	else {
      const modal = this.modalService.open(CommonAlertComponent, { backdrop: 'static', keyboard: false });
      modal.componentInstance.header = 'Email Required';
      modal.componentInstance.msg = 'We could not retrieve your email from LinkedIn. Please try signing in with a different method.';
    }

  }


	ngOnDestroy(): void {
		this.subs.unsubscribe();
	}
}
